module.exports = __webpack_public_path__ + "static/media/organization.1cc2a110.webp";